import React from 'react'

import { Box, Drawer, Typography, IconButton } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Close as CloseIcon } from '@mui/icons-material'

import { AccessoryDrawerPanes } from './AccessoryDrawerPanes'

import { closeAccessoryDrawer, useAccessoryDrawerStore } from '@edge/spark/io-dashboards'

const ToolContainer = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background-color: #eeeeee;
    padding: 10px;
    position: sticky;
    top: 0;
`

const ToolWidgetContainer = styled(Box)`
    display: flex;
    align-items: center;
`

const PaneContainer = styled(Box)`
    overflowy: auto;
    margin: 0 24px;
`

const Title = styled(Typography)`
    padding-left: 15px;
`

export const AccessoryDrawer: React.VFC = (): React.ReactElement => {
    const { open } = useAccessoryDrawerStore()
    const DrawerPane = open ? AccessoryDrawerPanes.find((pane) => 'WIDGET_CONFIG' === pane.enumValue) : null
    const PaneComponent = open ? DrawerPane?.Component : undefined

    return (
        <Drawer
            anchor="right"
            open={!!PaneComponent}
            onClose={closeAccessoryDrawer}
            transitionDuration={{
                enter: 600,
                exit: 600,
            }}
            // Class name referenced by AddWidgetItem
            className="dashboard-accessory-drawer"
            sx={{ '> .MuiDrawer-paper': { overflowX: 'scroll' } }}
        >
            {PaneComponent && (
                <Box>
                    <ToolContainer>
                        <Title variant="h6">{DrawerPane?.headerText}</Title>
                        <ToolWidgetContainer>
                            <IconButton onClick={closeAccessoryDrawer}>
                                <CloseIcon />
                            </IconButton>
                        </ToolWidgetContainer>
                    </ToolContainer>
                    <PaneContainer>
                        <PaneComponent />
                    </PaneContainer>
                </Box>
            )}
        </Drawer>
    )
}

export default AccessoryDrawer
